module.exports = __webpack_public_path__ + "img/2.596189dc.png";